module.exports = __webpack_public_path__ + "img/logo.2fff6cb2.png";